import { diff } from 'react-native-reanimated';
import { GameType } from '../components/screens/GameScreen';
import { performOperation } from '../components/screens/GameScreen/utils';
import { AIDifficultyLevel } from '../components/screens/PlayWithAI/useJoinAiGameMutation.gql';
import { GAME_TYPES_TYPE, OPERAND_TYPE, TAnswerRow } from '../constants/constants';
import journeyPathLine from '../resources/images/journeyPathLine.png';
import journeyPathLine1 from '../resources/images/journeyPathLine1.png';
import journeyPathLine2 from '../resources/images/journeyPathLine2.png';
import journeyPathLine3 from '../resources/images/journeyPathLine3.png';
import journeyPathLine4 from '../resources/images/journeyPathLine4.png';
import journeyPathLine5 from '../resources/images/journeyPathLine5.png';
import journeyPathLine6 from '../resources/images/journeyPathLine6.png';
import journeyPathLine7 from '../resources/images/journeyPathLine7.png';
import journeyPathLine8 from '../resources/images/journeyPathLine8.png';
import journeyPathLineMobile from '../resources/images/journeyPathLineMobile.png';
import journeyPathLineMobile1 from '../resources/images/journeyPathLineMobile1.png';
import journeyPathLineMobile2 from '../resources/images/journeyPathLineMobile2.png';
import journeyPathLineMobile3 from '../resources/images/journeyPathLineMobile3.png';
import journeyPathLineMobile4 from '../resources/images/journeyPathLineMobile4.png';
import journeyPathLineMobile5 from '../resources/images/journeyPathLineMobile5.png';
import journeyPathLineMobile6 from '../resources/images/journeyPathLineMobile6.png';
import journeyPathLineMobile7 from '../resources/images/journeyPathLineMobile7.png';
import journeyPathLineMobile8 from '../resources/images/journeyPathLineMobile8.png';

const bobBoss = require('../resources/images/bob-boss.png');

const ryanBoss = require('../resources/images/ryan-boss.png');
const ancaBoss = require('../resources/images/anca-boss.png');
const lijahBoss = require('../resources/images/lijah-boss.png');
const bobBot = require('../resources/images/bob-bot.png');
const ryanBot = require('../resources/images/ryan-bot.png');
const ancaBot = require('../resources/images/anca-bot.png');
const lijahBot = require('../resources/images/lijah-bot.png');

export type TStageType = 'Assessment' | 'Survey' | 'Level';

export enum EStageType {
  Assessment = 'Assessment',
  Survey = 'Survey',
  Level = 'Level',
}
export enum EJourneyGameBadgeType {
  Level = 'Level',
  Complete = 'Complete',
}

enum EStageName {
  Start = 'Start',
  Assessment1 = 'Buzz - Game 1',
  Survey1 = 'Survey 1',
  Level1 = 'Level 1',
  Level2 = 'Level 2',
  Level3 = 'Level 3',
  Assessment2 = 'Buzz - Game 2',
  Level4 = 'Level 4',
  Survey2 = 'Survey 2',
  Assessment3 = 'Buzz - Game 3',
}

export enum EStageId {
  Start = 'Start',
  Assessment1 = 'Assessment1',
  Survey1 = 'Survey1',
  Level1 = 'Level1',
  Level2 = 'Level2',
  Level3 = 'Level3',
  Assessment2 = 'Assessment2',
  Level4 = 'Level4',
  Survey2 = 'Survey2',
  Assessment3 = 'Assessment3',
}

export type TStage = {
  id: EStageId;
  stage: number;
  type: TStageType;
  name: EStageName;
  dotPosition?: 'top' | 'bottom' | 'left' | 'right';
  dotPositionMobile?: 'top' | 'bottom' | 'left' | 'right';
};

type TJourneyStages = {
  stages: TStage[];
  totalStages: number;
};

export default function getJourneyStages(): TJourneyStages {
  const stages: TStage[] = [
    {
      id: EStageId.Start,
      stage: 0,
      type: 'Assessment',
      name: EStageName.Start,
      dotPosition: 'left',
      dotPositionMobile: 'left',
    },
    {
      id: EStageId.Assessment1,
      stage: 1,
      type: 'Assessment',
      name: EStageName.Assessment1,
      dotPosition: 'left',
      dotPositionMobile: 'left',
    },
    {
      id: EStageId.Survey1,
      stage: 2,
      type: 'Survey',
      name: EStageName.Survey1,
      dotPosition: 'left',
      dotPositionMobile: 'right',
    },
    {
      id: EStageId.Level1,
      stage: 3,
      type: 'Level',
      name: EStageName.Level1,
      dotPosition: 'left',
      dotPositionMobile: 'top',
    },
    {
      id: EStageId.Level2,
      stage: 4,
      type: 'Level',
      name: EStageName.Level2,
      dotPosition: 'left',
      dotPositionMobile: 'top',
    },
    {
      id: EStageId.Level3,
      stage: 5,
      type: 'Level',
      name: EStageName.Level3,
      dotPosition: 'left',
      dotPositionMobile: 'top',
    },
    {
      id: EStageId.Assessment2,
      stage: 6,
      type: 'Assessment',
      name: EStageName.Assessment2,
      dotPosition: 'top',
      dotPositionMobile: 'right',
    },
    {
      id: EStageId.Level4,
      stage: 7,
      type: 'Level',
      name: EStageName.Level4,
      dotPosition: 'top',
      dotPositionMobile: 'top',
    },
    {
      id: EStageId.Survey2,
      stage: 8,
      type: 'Survey',
      name: EStageName.Survey2,
      dotPosition: 'top',
      dotPositionMobile: 'top',
    },
    {
      id: EStageId.Assessment3,
      stage: 9,
      type: 'Assessment',
      name: EStageName.Assessment3,
      dotPosition: 'top',
      dotPositionMobile: 'top',
    },
  ];

  return {
    stages,
    totalStages: stages.length,
  };
}

export type TStageStatus = 'done' | 'current' | 'locked';

export const getStageStatus = (stage: TStage, currentStage: number): TStageStatus => {
  if (stage.stage <= currentStage) {
    return 'done';
  } else if (stage.stage === currentStage + 1) {
    return 'current';
  } else {
    return 'locked';
  }
};

export const getStageStatusStyle = (status: TStageStatus) => {
  switch (status) {
    case 'done':
      return {
        colorIcon: '#E2753A',
        backColorIcon: '#FFF5DD',
        colorText: '#121212',
        buttonBackground: '#FFF5DD',
        dotColor: '#FDDB96',
      };
    case 'current':
      return {
        colorIcon: '#E2753A',
        backColorIcon: '#FFF5DD',
        colorText: '#121212',
        buttonBackground: '#FFFFFF',
        dotColor: '#FDDB96',
      };
    case 'locked':
      return {
        colorIcon: '#737373',
        backColorIcon: '#FFFDF8',
        colorText: '#737373',
        buttonBackground: '#FEF3D6',
        dotColor: '#A6A6A6',
      };
  }
};

export const getStageRoute = (stageType: TStageType) => {
  switch (stageType) {
    case 'Assessment':
      return 'JourneyAssessment';
    case 'Survey':
      return 'JourneySurvey';
    case 'Level':
      return 'JourneyLevel';
    default:
      return '';
  }
};

export const getPathLBackgroundLine = (stage: EStageId) => {
  switch (stage) {
    case EStageId.Start:
      return journeyPathLine;
    case EStageId.Assessment1:
      return journeyPathLine1;
    case EStageId.Survey1:
      return journeyPathLine2;
    case EStageId.Level1:
      return journeyPathLine3;
    case EStageId.Level2:
      return journeyPathLine4;
    case EStageId.Level3:
      return journeyPathLine5;
    case EStageId.Assessment2:
      return journeyPathLine6;
    case EStageId.Level4:
      return journeyPathLine7;
    case EStageId.Survey2:
    case EStageId.Assessment3:
      return journeyPathLine8;
    default:
      return journeyPathLine;
  }
};

export const getPathLBackgroundLineMobile = (stage: EStageId) => {
  switch (stage) {
    case EStageId.Start:
      return journeyPathLineMobile;
    case EStageId.Assessment1:
      return journeyPathLineMobile1;
    case EStageId.Survey1:
      return journeyPathLineMobile2;
    case EStageId.Level1:
      return journeyPathLineMobile3;
    case EStageId.Level2:
      return journeyPathLineMobile4;
    case EStageId.Level3:
      return journeyPathLineMobile5;
    case EStageId.Assessment2:
      return journeyPathLineMobile6;
    case EStageId.Level4:
      return journeyPathLineMobile7;
    case EStageId.Survey2:
    case EStageId.Assessment3:
      return journeyPathLineMobile8;
    default:
      return journeyPathLineMobile;
  }
};

export const getBeeBot = (name: EStageId) => {
  switch (name) {
    case EStageId.Level1:
      return 'Bob';
    case EStageId.Level2:
      return 'Ryan';
    case EStageId.Level3:
      return 'Anca';
    case EStageId.Level4:
      return 'Lijah';
    default:
      return 'AI';
  }
};

export const getBeeBotByDifficulty = (difficulty: AIDifficultyLevel) => {
  switch (difficulty) {
    case AIDifficultyLevel.EASY:
      return 'Bob';
    case AIDifficultyLevel.MEDIUM:
      return 'Ryan';
    case AIDifficultyLevel.HARD:
      return 'Anca';
    case AIDifficultyLevel.EXTREME:
      return 'Lijah';
    default:
      return 'AI';
  }
};

export const getBeeBotDifficulty = (name: EStageId) => {
  switch (name) {
    case EStageId.Level1:
      return AIDifficultyLevel.EASY;
    case EStageId.Level2:
      return AIDifficultyLevel.MEDIUM;
    case EStageId.Level3:
      return AIDifficultyLevel.HARD;
    case EStageId.Level4:
      return AIDifficultyLevel.EXTREME;
    default:
      return AIDifficultyLevel.EASY;
  }
};

export enum EAssessmentMode {
  Practice = 'Practice',
  Game = 'Game',
}

export const getAssessmentNameByStageId = (name: EStageId) => {
  switch (name) {
    case EStageId.Assessment1:
      return 'Buzz Game 1';
    case EStageId.Assessment2:
      return 'Buzz Game 2';
    case EStageId.Assessment3:
      return 'Buzz Game 3';
    default:
      return 'Buzz';
  }
};

export function generateAnswerTableAssessment(
  leftOperands: OPERAND_TYPE[],
  rightOperands: OPERAND_TYPE[],
  gameType: GAME_TYPES_TYPE,
): TAnswerRow[] {
  const map = new Map<string, TAnswerRow>();

  for (const left of leftOperands) {
    for (const right of rightOperands) {
      const result = performOperation({ gameType, leftOperand: left, rightOperand: right });
      const key = JSON.stringify(result);

      if (!map.has(key)) {
        map.set(key, { answer: result, pairs: [] });
      }

      map.get(key)!.pairs.push({ left, right });
    }
  }

  return Array.from(map.values());
}

function shuffle<T>(arr: T[]): T[] {
  const copy = [...arr];
  for (let i = copy.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [copy[i], copy[j]] = [copy[j], copy[i]];
  }
  return copy;
}

export function pickRandomAnswersAssessment(table: TAnswerRow[], limit: number = 20): TAnswerRow[] {
  return shuffle(table).slice(0, limit);
}

export function checkUserAnswerAssessment(
  answerRow: TAnswerRow,
  leftOperand: OPERAND_TYPE,
  rightOperand: OPERAND_TYPE,
): boolean {
  return answerRow.pairs.some(
    pair =>
      pair.left.a === leftOperand.a &&
      pair.right.a === rightOperand.a &&
      (pair.left.x ?? 0) === (leftOperand.x ?? 0) &&
      (pair.right.x ?? 0) === (rightOperand.x ?? 0) &&
      (pair.left.c ?? 0) === (leftOperand.c ?? 0) &&
      (pair.right.c ?? 0) === (rightOperand.c ?? 0) &&
      (pair.left.y ?? 0) === (leftOperand.y ?? 0) &&
      (pair.right.y ?? 0) === (rightOperand.y ?? 0) &&
      (pair.left.b ?? 0) === (leftOperand.b ?? 0) &&
      (pair.right.b ?? 0) === (rightOperand.b ?? 0),
  );
}

export const getMascot = ({
  difficultyLevel,
  bossUnlocked,
}: {
  difficultyLevel: AIDifficultyLevel;
  bossUnlocked?: boolean;
}) => {
  if (!bossUnlocked) {
    switch (difficultyLevel) {
      case AIDifficultyLevel.EASY:
        return bobBoss;
      case AIDifficultyLevel.MEDIUM:
        return ryanBoss;
      case AIDifficultyLevel.HARD:
        return ancaBoss;
      case AIDifficultyLevel.EXTREME:
        return lijahBoss;
      default:
        return bobBoss;
    }
  } else {
    switch (difficultyLevel) {
      case AIDifficultyLevel.EASY:
        return bobBot;
      case AIDifficultyLevel.MEDIUM:
        return ryanBot;
      case AIDifficultyLevel.HARD:
        return ancaBot;
      case AIDifficultyLevel.EXTREME:
        return lijahBot;
      default:
        return bobBot;
    }
  }
};
